import Vue from 'vue'

export default {
  getPsap: function () {
    let apiDetailPath = '/psaps'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.token.idToken} })
  },
  getPsapLiveSnapshot: function () {
    let apiDetailPath = '/psaps/live'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.token.idToken} })
  },
  getPsapLiveSnapshotUrlV2: function () {
    let apiDetailPath = '/psaps/snapshot_url'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.token.idToken} })
  },
  getPsapLiveSnapshotV2: function (snapshotUrl, token) {
    let fullUrl = snapshotUrl + '?duration=10&interval=0'
    return Vue.http.get(fullUrl, { headers: {'Authorization': 'Bearer ' + token} })
  },
  getPsapEvent: function () {
    let apiDetailPath = '/psaps/event'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.token.idToken} })
  }
}



// WEBPACK FOOTER //
// ./src/apis/psap.js